

















































































import { defineComponent, reactive, toRefs, onMounted, ref } from '@vue/composition-api'
import * as Common from "../../commons/common"
import http from "../../plugins/http"
import AlertArea from "../../components/AlertArea.vue"
import MasterMainteTab from "../../components/MasterMainteTab.vue"
import { BTable } from 'bootstrap-vue'
import { SearchCondition, Lesson } from "../../modules/teacher/LessonList"

export interface Data {
  tabNo: number
  condition: SearchCondition
  lessons: Lesson[]
  fields: any[]
  isShowPagination: boolean
  isAllDeleteChecked: boolean
  totalCount: number
  errors: string[]
}

export default defineComponent({
  components: {
    "master-mainte-tab": MasterMainteTab,
    "alert-area": AlertArea,
  },
  setup(props, context){

    const tableRef = ref<InstanceType<typeof BTable>>();

    /************************************************************
     * data
     ************************************************************/

    const state = reactive<Data>({
      tabNo: 8,
      condition: new SearchCondition(),
      lessons: new Array<Lesson>(),
      fields: [
        {key: "lesson_code", label: "講座CD", sortable: true, class: 'text-center b-table-th-td'},
        {key: "name", label: "講座名", sortable: true, class: 'text-center b-table-th-td'},
        {key: "subject_code", label: "科目CD", sortable: true, class: 'text-center b-table-th-td'},
        {key: "subject_name", label: "科目名", sortable: true, class: 'text-center b-table-th-td'},
        {key: "nendo", label: "年度", sortable: true, class: 'text-center b-table-th-td'},
        {key: "user_name", label: "担当講師", sortable: true, class: 'text-center b-table-th-td'},
        {key: "goal_comment", label: "学習目標", sortable: true, class: 'text-center b-table-th-td'},
        {key: "message", label: "メッセージ", sortable: true, class: 'text-center b-table-th-td'},
        // {key: "grade", label: "学年", sortable: true, class: 'text-center b-table-th-td'},
        // {key: "kumi", label: "組", sortable: true, class: 'text-center b-table-th-td'},
        // {key: "student_no", label: "出席番号", sortable: true, class: 'text-center b-table-th-td'},
        // {key: "status", label: "在校状態", sortable: true, class: 'text-center b-table-th-td'},
        {key: "delete", label: "削除", class: 'text-center', thStyle: {width: "80px"}},
      ],
      errors: [],
      isShowPagination: false,
      isAllDeleteChecked: false,
      totalCount: 0.
    });

    /******************************
     * 検索ボタンクリック
     ******************************/

    const searchButtonClick = async () => {
      state.condition.page = 1;
      await search();
    }

    /******************************
     * ページング
     ******************************/

    const changePage = async (page: number) => {
      state.condition.page = page;
      search();
    };

    /******************************
     * 全件選択
     ******************************/

    const allSelectChanged = (isChecked: boolean) => {
      tableRef.value.computedItems.forEach((x: any) => x.is_checked = isChecked);
    };

    /******************************
     * 削除
     ******************************/

    const deleteMst = async (): Promise<void> => {

      if(state.lessons.filter(x => x.is_checked).length == 0){
        alert("削除対象が選択されていません。");
        return;
      }

      if(!window.confirm("削除を実行します。よろしいですか？")){
        return;
      }
      
      context.root.$store.dispatch("showOverlay");
      state.errors = [];
      const delete_ids: number[] = state.lessons.filter(x => x.is_checked).map(x => x.id);

      await http.post(`/api/teacher/lesson_list/delete`, {ids: delete_ids}).then(response => {
        alert(`削除処理が完了しました。`);
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = [`予期せぬ例外が発生しました。`];
        }
      });

      context.root.$store.dispatch("hideOverlay");

      search();
    };

    /******************************
     * 検索API
     ******************************/

    const search = async () => {
      state.errors = [];
      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");
      await http.get(`/api/teacher/lesson_list?${Common.BuildQuery(state.condition, 'search_condition')}`).then(response => {
        state.lessons = response.data.lessons.map((x: any) => new Lesson(x));
        state.totalCount = response.data.full_count
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    };

    /******************************
     * 検索条件クリア
     ******************************/

    const clearCondition = () => {
      state.condition = new SearchCondition();
    };

    /******************************
     * Excelダウンロード
     ******************************/

    const download = async () => {

      context.root.$store.dispatch("showOverlay", "ダウンロード中... しばらくお待ちください。");
      state.errors = [];

      await http.get(`/api/teacher/lesson_list/download?${Common.BuildQuery(state.condition, 'search_condition')}`, {responseType: 'arraybuffer'}).then(async response => {
        const blob = new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
        const a = document.createElement('a');
        a.href = window.URL.createObjectURL(blob);
        a.download = `講座マスタ.xlsx`;
        a.click();
      })
      .catch(error=>{
        if(error.response.status == 422){
          const errorData = JSON.parse((new TextDecoder).decode(new Uint8Array(error.response.data)));
          alert(`エクセルのダウンロードに失敗しました。\n${errorData.errors[0]}`);
        }else{
          alert("エクセルのダウンロードに失敗しました。");
        }
      });

      context.root.$store.dispatch("hideOverlay");
    }

    /******************************
     * mounted
     ******************************/
    
    onMounted(async () => {
      await search();
      state.isShowPagination = true;
    });

    return {
      ...toRefs(state),
      tableRef,
      search,
      clearCondition,
      changePage,
      allSelectChanged,
      deleteMst,
      download,
      searchButtonClick,
    };
  }
});
